<template>
  <div
    :class="[
      'owc-wb-accordion',
      {
        'owc-wb-accordion--dark': isDarkMode,
      },
    ]"
  >
    <div class="wb-grid-container">
      <ValidationBoxWrapper v-if="isEditMode">
        <slot slot="validation-box" name="validation-box" />
      </ValidationBoxWrapper>
      <wb-accordion :theme="isDarkMode ? 'dark' : ''" ref="wbAccordion">
        <wb-accordion-item
          v-for="(accordionItem, index) in accordionItems"
          :key="accordionItem.headline"
          :open="isEditMode"
          :class="{ 'hidden-accordion-item': isAccordionItemHidden(accordionItem.id) }"
        >
          <wb-accordion-toggle @click="handleAccordionItemClick(index, accordionItem.headline)">
            {{ accordionItem.headline }}
          </wb-accordion-toggle>
          <wb-accordion-section class="owc-wb-accordion__section">
            <wb-accordion-mobile-header>{{ globalBackLabel }}</wb-accordion-mobile-header>
            <wb-accordion-content class="owc-accordion-content">
              <SlotContainer
                refName="slot-accordion-content"
                :slotName="accordionItem.id"
                :slot-component-data="JSON.stringify({ darkMode: isDarkMode })"
              >
                <slot :slot="accordionItem.id" :name="accordionItem.id" />
              </SlotContainer>
            </wb-accordion-content>
          </wb-accordion-section>
        </wb-accordion-item>
      </wb-accordion>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { WbAccordionComponent } from './WbAccordion';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default (ComponentInitializeDispatcher as WbAccordionComponent).extend({
  name: 'owc-wb-accordion',
  mixins: [OwcDataComponent],
  components: {
    SlotContainer,
    ValidationBoxWrapper,
  },
  data() {
    return {
      hiddenAccordionIdsSet: new Set<string>(),
    };
  },
  computed: {
    accordionItems: function() {
      return this.componentData?.items;
    },
    globalBackLabel: function() {
      return this.componentData?.globalBackLabel;
    },
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
  },
  methods: {
    handleAccordionItemClick: function(index, wbItemLabel) {
      if (this.componentData?.parentTab) {
        const tabContent = this.componentData.parentTab;
        const tabLabel = `tab${tabContent.tabIndex}.${tabContent.label}`;
        const wbAccordionItemIndex = index + 1;
        const wbAccordionItemLabel = `subtab${wbAccordionItemIndex}.${wbItemLabel}`;
        const element = this.$refs.wbAccordion;

        this.handleCustomTracking(element, `${tabLabel}.${wbAccordionItemLabel}`, 'feature', 'click');
      }
    },
    isAccordionItemHidden(itemId) {
      return this.hiddenAccordionIdsSet.has(itemId);
    },
  },
  mounted() {
    const editModeElement = document.querySelector('[data-edit-mode]');
    if (!editModeElement) {
      const hiddenOwcAccordionList = document.querySelectorAll(
        'owc-wb-accordion-item[data-aem-targeting-hidden-initially]',
      );

      hiddenOwcAccordionList.forEach(item => {
        const id = item.getAttribute('component-id');
        if (id) {
          this.hiddenAccordionIdsSet.add(id);
        }
      });
    }
  },
});
</script>

<!--WORKBENCH OVERRIDES-->
<style lang="scss">
@import '@owc-styles/utils/z-index-list';

.owc-wb-accordion {
  box-sizing: border-box;

  //Forces higher specificity
  .owc-wb-accordion__section {
    @include breakpoint-to(mq5) {
      z-index: $z-index-overlay;
    }
  }
  .wb-accordion__bg-dark {
    display: none;
  }
  &--dark {
    background-color: var(--wb-black);
  }
  .hidden-accordion-item {
    display: none;
  }
}
</style>
